import { PublishTradingOfferModalContextType } from '../types/PublishTradingOfferModalContextType';

export const publishTradingOfferModalInitValue: PublishTradingOfferModalContextType =
  {
    data: {
      modalActionType: '',
      tradingOffer: null,
      validityDays: 0,
      isTermsAndConditionsAccepted: false,
      isLoading: true,
    },
    actions: {
      handleCloseModal: () => {},
      handleChangeTermsAndConditionsAcceptance: () => {},
      handlePublishTradingOffer: async () => {},
    },
  };
